<script setup lang="ts">
    import type { AiMessage } from '~/stores/aiAssistantTypes';
    import { useAuthStore } from '~/stores/authStore';

    const authStore = useAuthStore();

    defineProps<{
        message: AiMessage;
    }>();

    const formattedTime = (d: Date) =>
        `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
</script>

<template>
    <div class="flex justify-end gap-[8px] py-[8px] w-full">
        <div class="flex flex-col items-end max-w-[70%]">
            <div class="bg-white border border-[#E7E7E7] px-[14px] py-[10px] rounded-[12px] rounded-br-[4px] shadow-[0_1px_2px_rgba(15,16,32,0.05)]">
                <p class="font-inter text-[13px] leading-[1.5] text-gray-900 whitespace-pre-wrap">
                    {{ message.content }}
                </p>
            </div>
            <span class="mt-1 font-poppins text-[10px] text-[#abb5c0]">{{ formattedTime(message.timestamp) }}</span>
        </div>
        <AuthUserAvatar
            :user="authStore.authed"
            size="w-[26px] h-[26px]"
            :clickable-avatar="false"
        />
    </div>
</template>
